import * as Yup from 'yup';
import { validateNationalCode, validateMobileNumber } from '../utils/validators';

/**
 * Custom Yup validators for Persian/Iranian data
 */

// Add custom national code validator
Yup.addMethod(Yup.string, 'nationalCode', function (message = 'کد ملی نامعتبر است') {
    return this.test('national-code', message, function (value) {
        const { path, createError } = this;

        if (!value) return true; // Let required() handle empty values

        return validateNationalCode(value) || createError({ path, message });
    });
});

// Add custom mobile number validator
Yup.addMethod(Yup.string, 'mobileNumber', function (message = 'شماره موبایل نامعتبر است') {
    return this.test('mobile-number', message, function (value) {
        const { path, createError } = this;

        if (!value) return true; // Let required() handle empty values

        return validateMobileNumber(value) || createError({ path, message });
    });
});

// Add custom file size validator
Yup.addMethod(Yup.mixed, 'fileSize', function (maxSize, message) {
    return this.test('file-size', message || `حجم فایل نباید بیشتر از ${maxSize}MB باشد`, function (value) {
        const { path, createError } = this;

        if (!value) return true; // Let required() handle empty values

        const sizeInMB = value.size / 1024 / 1024;
        return sizeInMB <= maxSize || createError({ path, message });
    });
});

// Add custom file type validator
Yup.addMethod(Yup.mixed, 'fileType', function (allowedTypes, message) {
    return this.test('file-type', message || 'فرمت فایل نامعتبر است', function (value) {
        const { path, createError } = this;

        if (!value) return true; // Let required() handle empty values

        const types = Array.isArray(allowedTypes) ? allowedTypes : [allowedTypes];
        return types.includes(value.type) || createError({ path, message });
    });
});

// Add Persian date validator (YYYY/MM/DD or YYYY-MM-DD for JalaliDatePicker Gregorian output)
Yup.addMethod(Yup.string, 'persianDate', function (message = 'فرمت تاریخ باید YYYY/MM/DD باشد') {
    return this.test('persian-date', message, function (value) {
        const { path, createError } = this;

        if (!value) return true; // Let required() handle empty values

        const dateRegex = /^\d{4}[\/-]\d{2}[\/-]\d{2}$/;
        if (!dateRegex.test(value)) return createError({ path, message });
        const normalized = value.replace(/\//g, '-');
        const parsed = new Date(normalized);
        return !Number.isNaN(parsed.getTime()) || createError({ path, message });
    });
});

// Add age validator (minimum age) - supports both YYYY/MM/DD and YYYY-MM-DD
Yup.addMethod(Yup.string, 'minAge', function (minAge, message) {
    return this.test('min-age', message || `سن باید حداقل ${minAge} سال باشد`, function (value) {
        const { path, createError } = this;

        if (!value) return true; // Let required() handle empty values

        const normalized = value.replace(/\//g, '-');
        const birthDate = new Date(normalized);
        if (Number.isNaN(birthDate.getTime())) return createError({ path, message });
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }

        return age >= minAge || createError({ path, message });
    });
});

export default Yup;
